import type { FeatureToggleResponseDto } from '@trellis/api'

import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

export const getFeatureFlags = () =>
  request<FeatureToggleResponseDto[]>(() =>
    apiClient.api.featureFlagsControllerGetFeatureFlags(),
  )
